(function () {
  'use strict';

  var STORAGE_KEY = 'engrave_variant_ids';

  // ── Get engrave variant IDs ──────────────────────────────────────────────────

  function getEngraveVariantIds() {
    var ids = new Set();
    document.querySelectorAll(
      '.custom_prd_div[data-engrave-variant-id]:not([data-engrave-variant-id=""])'
    ).forEach(function (el) {
      if (el.dataset.engraveVariantId) ids.add(String(el.dataset.engraveVariantId));
    });
    try {
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      stored.forEach(function (id) { ids.add(String(id)); });
    } catch (e) {}
    if (window.engraveVariantIds && Array.isArray(window.engraveVariantIds)) {
      window.engraveVariantIds.forEach(function (id) { ids.add(String(id)); });
    }
    return ids;
  }

  function persistEngraveVariantIds() {
    var ids = [];
    document.querySelectorAll(
      '.custom_prd_div[data-engrave-variant-id]:not([data-engrave-variant-id=""])'
    ).forEach(function (el) {
      if (el.dataset.engraveVariantId) ids.push(String(el.dataset.engraveVariantId));
    });
    if (ids.length > 0) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(ids)); } catch (e) {}
    }
  }

  // ── Hide qty + remove controls for engrave rows ──────────────────────────────

  function hideEngraveItemControls() {
    var engraveIds = getEngraveVariantIds();
    if (engraveIds.size === 0) return;
    document.querySelectorAll('tr.cart-item').forEach(function (row) {
      var input = row.querySelector('input.quantity__input[data-quantity-variant-id]');
      if (!input) return;
      if (!engraveIds.has(String(input.dataset.quantityVariantId))) return;
      row.setAttribute('data-engrave-item', 'true');
      [
        row.querySelector('.cart-item__quantity-wrapper_remove'),
        row.querySelector('cart-remove-button'),
        row.querySelector('td.cart-item__quantity'),
      ].forEach(function (el) {
        if (el) {
          el.style.setProperty('opacity', '0', 'important');
          el.style.setProperty('pointer-events', 'none', 'important');
        }
      });
    });
  }

  // ── Core: Intercept fetch and COMBINE main remove + engrave remove ───────────
  //
  // STRATEGY: When Shopify calls /cart/change.js to remove (quantity=0),
  // we INTERCEPT it, check if engrave item is in cart,
  // and REPLACE the /cart/change.js call with a single /cart/update.js
  // that removes BOTH main item AND engrave item together in one request.
  // This means Shopify's re-render will already have both removed.

  var _fetch = window.fetch;

  window.fetch = function (resource, options) {
    var url = typeof resource === 'string' ? resource
              : (resource && resource.url ? resource.url : '');

    // Only intercept cart remove calls
    if (url.includes('/cart/change')) {
      var bodyStr = (options && options.body) ? options.body : '';
      var bodyObj = null;
      try { bodyObj = typeof bodyStr === 'string' ? JSON.parse(bodyStr) : null; } catch (e) {}

      // Only act on removal (quantity = 0)
      if (bodyObj && String(bodyObj.quantity) === '0') {

        var engraveIds = getEngraveVariantIds();

        // If no engrave IDs known, just pass through normally
        if (engraveIds.size === 0) {
          return _fetch.apply(window, [resource, options]);
        }

        // Check current cart for engrave items
        return _fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            // Find the main item being removed by line number
            var lineIndex = parseInt(bodyObj.line, 10) - 1; // 0-indexed
            var mainItem = cart.items[lineIndex];

            // Is the item being removed itself an engrave item? Pass through.
            if (mainItem && engraveIds.has(String(mainItem.variant_id))) {
              return _fetch.apply(window, [resource, options]);
            }

            // Find engrave items in cart
            var engraveInCart = [];
            cart.items.forEach(function (item, idx) {
              if (engraveIds.has(String(item.variant_id))) {
                engraveInCart.push({ variant_id: item.variant_id, line: idx + 1 });
              }
            });

            if (engraveInCart.length === 0) {
              // No engrave in cart — pass through normally
              return _fetch.apply(window, [resource, options]);
            }

            // Build a SINGLE /cart/update.js call that removes both
            // main item (by line) and engrave items (by variant_id)
            var updates = {};

            // Remove main item by variant_id
            if (mainItem) {
              updates[String(mainItem.variant_id)] = 0;
            }

            // Remove engrave items
            engraveInCart.forEach(function (ei) {
              updates[String(ei.variant_id)] = 0;
            });

            // Build the same sections/sections_url that Shopify expects
            // so the cart drawer re-renders correctly
            var sectionsParam = bodyObj.sections || [];
            var sectionsUrl = bodyObj.sections_url || window.location.pathname;

            return _fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                updates: updates,
                sections: sectionsParam,
                sections_url: sectionsUrl,
              }),
            });
          })
          .catch(function () {
            // On any error, fall through to original
            return _fetch.apply(window, [resource, options]);
          });
      }
    }

    return _fetch.apply(window, arguments);
  };

  // ── XHR interceptor (fallback) ───────────────────────────────────────────────

  var _xhrOpen = XMLHttpRequest.prototype.open;
  var _xhrSend = XMLHttpRequest.prototype.send;
  var _xhrMethod = '';
  var _xhrUrl = '';

  XMLHttpRequest.prototype.open = function (method, url) {
    this._engraveMethod = method;
    this._engraveUrl = url || '';
    return _xhrOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    var url = this._engraveUrl || '';
    if (url.includes('/cart/change')) {
      var bodyObj = null;
      try { bodyObj = typeof body === 'string' ? JSON.parse(body) : null; } catch (e) {}
      if (bodyObj && String(bodyObj.quantity) === '0') {
        var engraveIds = getEngraveVariantIds();
        if (engraveIds.size > 0) {
          var self = this;
          // Fire a separate update to remove engrave items after XHR completes
          self.addEventListener('load', function () {
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var updates = {};
                var found = false;
                cart.items.forEach(function (item) {
                  if (engraveIds.has(String(item.variant_id))) {
                    updates[String(item.variant_id)] = 0;
                    found = true;
                  }
                });
                if (!found) return;
                return fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ updates: updates }),
                }).then(function () {
                  window.location.reload();
                });
              })
              .catch(function (err) { console.error('[Engrave] XHR fallback error:', err); });
          });
        }
      }
    }
    return _xhrSend.apply(this, arguments);
  };

  // ── MutationObserver: re-apply hide after every cart re-render ───────────────

  function observeAndHide() {
    var targets = [
      document.querySelector('#CartDrawer'),
      document.querySelector('#main-cart-items'),
    ].filter(Boolean);
    if (targets.length === 0) { setTimeout(observeAndHide, 400); return; }
    targets.forEach(function (target) {
      var obs = new MutationObserver(function () {
        clearTimeout(obs._t);
        obs._t = setTimeout(hideEngraveItemControls, 100);
      });
      obs.observe(target, { childList: true, subtree: true });
    });
  }

  // ── INIT ─────────────────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    persistEngraveVariantIds();
    hideEngraveItemControls();
    observeAndHide();
  });

})();